module.exports = __webpack_public_path__ + "img/pr-2.05236186.png";